var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClipboardText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3596 11.4746H17.6396C13.9346 11.4746 10.9346 14.4896 10.9346 18.1796V32.2946C10.9346 35.9846 13.9496 38.9996 17.6396 38.9996H30.3446C34.0496 38.9996 37.0496 35.9846 37.0496 32.2946V18.1796C37.0646 14.4746 34.0496 11.4746 30.3596 11.4746Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5246 9H20.4746C18.9146 9 17.6396 10.26 17.6396 11.82V13.23C17.6396 14.79 18.8996 16.05 20.4596 16.05H27.5246C29.0846 16.05 30.3446 14.79 30.3446 13.23V11.82C30.3596 10.26 29.0846 9 27.5246 9Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 25.4258H18C17.385 25.4258 16.875 24.9158 16.875 24.3008C16.875 23.6858 17.385 23.1758 18 23.1758H28.5C29.115 23.1758 29.625 23.6858 29.625 24.3008C29.625 24.9158 29.115 25.4258 28.5 25.4258Z",
    fill: "#111827"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.57 31.4258H18C17.385 31.4258 16.875 30.9158 16.875 30.3008C16.875 29.6858 17.385 29.1758 18 29.1758H24.57C25.185 29.1758 25.695 29.6858 25.695 30.3008C25.695 30.9158 25.185 31.4258 24.57 31.4258Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardText);
export default __webpack_public_path__ + "static/media/clipboardText.a8554088bfbd29f1152ffd7e3248c700.svg";
export { ForwardRef as ReactComponent };